import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

/**
 * Raízes da árvore que contêm unidades (`portal_type: Locations`).
 *
 * São duas: `/o-mpf/unidades` (unidades territoriais) e `/o-mpf/estrutura`
 * (estrutura organizacional). Os dois ramos guardam o mesmo tipo de conteúdo
 * e respondem aos mesmos serviços (`@contato`, `@assinatura`, `@noticias`).
 */
export const UNIDADE_ROOTS = ['/o-mpf/unidades', '/o-mpf/estrutura'] as const;

/**
 * Normaliza para um caminho de aplicação sem barra final — aceita tanto
 * `location.pathname` quanto o `@id` absoluto que vem da API.
 */
const toPath = (url?: string): string =>
  flattenToAppURL(url || '')
    .split(/[?#]/)[0]
    .replace(/\/+$/, '');

/** O caminho está dentro de um dos ramos de unidade? */
export function isUnidadePath(url?: string): boolean {
  const path = toPath(url);
  return UNIDADE_ROOTS.some(
    (root) => path === root || path.startsWith(`${root}/`),
  );
}

/**
 * Caminho a usar nas chamadas dos serviços da unidade, ou `null` quando o
 * conteúdo não está sob unidade nenhuma.
 *
 * É o caminho do **próprio conteúdo**, não o da unidade: `@contato`,
 * `@assinatura` e `@noticias` sobem a árvore no backend até o ancestral que
 * interessa (o `Locations` mais próximo; no caso de `@noticias`, a pasta
 * `noticias`). Por isso isto funciona em qualquer profundidade — inclusive
 * numa unidade aninhada, como
 * `/o-mpf/estrutura/procuradorias-regionais/prr6/noticias/uma-noticia`, em
 * que tentar adivinhar o id da unidade pelo 3º segmento pegaria
 * `procuradorias-regionais`.
 */
export function getUnidadeServicePath(url?: string): string | null {
  return isUnidadePath(url) ? toPath(url) : null;
}
